module.exports = __webpack_public_path__ + "static/media/proj.c73fedf0.png";